var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0002 100.791C66.0811 100.791 84.7919 82.0806 84.7919 58.9997C84.7919 35.9188 66.0811 17.208 43.0002 17.208C19.9193 17.208 1.2085 35.9188 1.2085 58.9997C1.2085 82.0806 19.9193 100.791 43.0002 100.791Z",
    stroke: "#B78727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9998 83.5832C56.5768 83.5832 67.5832 72.5768 67.5832 58.9998C67.5832 45.4228 56.5768 34.4165 42.9998 34.4165C29.4228 34.4165 18.4165 45.4228 18.4165 58.9998C18.4165 72.5768 29.4228 83.5832 42.9998 83.5832Z",
    stroke: "#B78727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9998 68.8332C48.4306 68.8332 52.8332 64.4306 52.8332 58.9998C52.8332 53.569 48.4306 49.1665 42.9998 49.1665C37.569 49.1665 33.1665 53.569 33.1665 58.9998C33.1665 64.4306 37.569 68.8332 42.9998 68.8332Z",
    stroke: "#B78727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 59L73.2341 27.9944M73.2341 27.9944V17.085L87.1305 3.6875L87.8817 13.0657L97.0833 13.8313L83.7503 27.9944H73.2341Z",
    stroke: "#B78727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.e21d258457f16b2a6707bff82e2e6ed8.svg";
export { ForwardRef as ReactComponent };